import { ShowFlash } from 'ng2/shared/flash/store/flash.actions';

module.exports = {
  templateUrl: 'profile/components/tabs/change-password/change-password.html',
  controller: class ChangePassword {

    static $inject =[
      '$ngRedux',
      'PatientAppContextService',
      'PatientsService',
      'SecurityService',
    ];

    constructor($ngRedux, PatientAppContextService, PatientsService, SecurityService) {
      this.$ngRedux = $ngRedux;
      this.PatientAppContextService = PatientAppContextService;
      this.PatientsService = PatientsService;
      this.SecurityService = SecurityService;
    }

    $onInit() {
      this.noServerErrors = {
        password: {},
        newPassword: {},
      };
      this.resetServerErrors();
    }

    submit() {
      this.resetServerErrors();
      if (this.form.$valid) {
        this.submitting = true;
        this.showConfirmation = true;
      }
    }

    cancel() {
      this.resetForm();
    }

    confirm() {
      this.showConfirmation = false;
      this.params = {
        password: this.password,
        newPassword: this.newPassword,
        confirmNewPassword: this.confirmNewPassword,
      };
      this.PatientsService.changePassword(this.PatientAppContextService.context.authenticatedPatient.id, this.params)
        .then(this.changePasswordSuccess, this.changePasswordError);
    }

    dismiss() {
      this.showConfirmation = false;
      this.submitting = false;
      this.resetForm();
    }

    changePasswordSuccess = () => {
      this.submitting = false;
      this.resetForm();
      this.$ngRedux.dispatch(new ShowFlash({ name: 'info', additionalInfos: { title: 'update.password.updateSuccess' } }));
    };

    changePasswordError = (error) => {
      this.submitting = false;
      if (error.status === 403 && error.data.error === 'Wrong password') {
        this.serverErrors.password.wrongPassword = true;
        this.form.password.$setPristine();
      } else if (error.status === 400 && error.data.error === 'Password not changed') {
        this.serverErrors.newPassword.samePassword = true;
        this.form.newPassword.$setPristine();
      } else {
        this.resetForm();
        this.$ngRedux.dispatch(new ShowFlash({ name: 'error' }));
      }
    };

    resetForm() {
      this.password = '';
      this.newPassword = '';
      this.confirmNewPassword = '';
      this.form.$setPristine();
      this.form.$setUntouched();
      this.resetServerErrors();
    }

    hasError(field) {
      return !this.form || ((this.form[field].$invalid && (this.form[field].$touched || this.form.$submitted)) || (!_.isEmpty(this.serverErrors[field]) && this.form[field].$pristine));
    }

    resetServerErrors() {
      this.serverErrors = angular.copy(this.noServerErrors);
    }

    clinics() {
      return this.PatientAppContextService.context.patient.clinics;
    }

  },
};



// WEBPACK FOOTER //
// ./profile/components/tabs/change-password/change-password.js